import Cookies from "js-cookie";
import { http } from "../utils/http";

export const UpdateProfileApi = async (data) => {
  try {
    const res = await http.post("/Profile/update-profile", {
      ...data,
    });
    return res;
  } catch (error) {}
};

export const UpdatePassword = async (data) => {
  const res = localStorage.getItem("userData");
  const { email, id } = JSON.parse(res);
  try {
    const res = await http.post("/Profile/update-password", {
      email,
      id,
      ...data,
    });
    return res;
  } catch (error) {}
};
